module.exports = __webpack_public_path__ + "img/aq.65a5c99.svg";